<app-header-public class="top-0"></app-header-public>
<main>
    <ng-content class="h-screen"></ng-content>
</main>
